<div class="chat-bi-direction" *ngIf="showMessaging">
  <div class="chat-direction">
    <div class="chat-cont">
      <div class="chayt-header collapse" id="chat-pop">

        <div class="chat-head" *ngIf="isTender">
          <label>{{ 'SHARED.TenderNumber' | translate}}: {{message?.TenderNumber}}</label>
          <label *ngIf="isGeneralMessage">{{ 'SHARED.ToAllSuppliers' | translate}}</label>
          <label *ngIf="!isGeneralMessage &&  isAdmin">{{ 'SHARED.To' | translate}}: {{message?.SupplierCompanyName}}</label>
          <label *ngIf="!isGeneralMessage && !isAdmin">{{ 'SHARED.ToSCATeam' | translate}}</label>
          <span (click)="removeErrors()" class="close-btn" data-toggle="collapse" data-target="#chat-pop"
            aria-expanded="false" aria-controls="chat-pop">&#8722;</span>
        </div>

        <div class="chat-head" *ngIf="!isTender">
          <div>
            <label>{{ 'SHARED.MyMessages.RequestNumber' | translate}}: {{message?.RequestNumber}}</label>
            <button type="button" *ngIf="isAdmin" class="chat-print-btn icon-print" [disabled]="isSending"
                title="{{ 'SHARED.Print' | translate}}" (click)="printMessages()"></button>
          </div>
          <label>{{ 'SHARED.MyMessages.ServiceName' | translate}}:
            {{currentLanguage == "Ar" ? message?.ServiceNameAR : message?.ServiceNameEN}}</label>

          <span (click)="removeErrors()" class="close-btn" data-toggle="collapse" data-target="#chat-pop"
            aria-expanded="false" aria-controls="chat-pop">&#8722;</span>
        </div>

        <div class="chat-body">

        </div>
        <div class="chat-inputs">
          <a class="mark-read" Confirmation (confirmationClick)="markMyReceivedMessagesAsRead()">
            {{ 'SHARED.MarkAsRead' | translate}}
          </a>
          <div class="chat-inputs-cont">
            <span class="sent-failed" *ngIf="messageFailed">
              {{'SHARED.SomthingWentWrong' | translate}}
            </span>
            <span class="sent-failed" *ngIf="isFileExtentionNotAllowed">
              {{'FRONT_USER.NotAllowedFileExtentionMessage' | translate}}
            </span>
            <span class="sent-failed" *ngIf="isFileSizeNotAllowed">
              {{'FRONT_USER.NotAllowedFileSize' | translate}}
            </span>
            <textarea [disabled]="isMessageBoxDisabled" name="chat-text" id="chat-text" [(ngModel)]="message.Body"
              (keydown.enter)="sendMessage();false"
              placeholder="{{ 'SHARED.MessagePlaceHolder' | translate}}"></textarea>
            <div class="text-right" *ngIf="isMessageBoxDisabled.toString() == 'false'" >
              <label for="chat-attchament" class="icon-attachment" *ngIf="isSending == false"
                title="{{ 'SHARED.AttachFiles' | translate}}"></label>
              <button type="button" class="chat-send-btn  icon-sent-mail" [disabled]="isSending"
                title="{{ 'SHARED.Send' | translate}}" (click)="sendMessage()"></button>
            </div>
          </div>
          <div class="chat-uploads-cont">
            <p class="chat-uploaded-files" title="{{DocumentName}}">{{DocumentName}}</p>
            <span class="icon-delete" *ngIf="message.MessageAttachments != null" (click)="removeFile()"
              title="{{ 'SHARED.RemoveAttachement' | translate}}"></span>
          </div>

          <input type="file" id="chat-attchament" class="chat-files" MaxSizeInMB="5"
            [(ngModel)]="message.MessageAttachments"
            accept=".pdf,.PDF, .gif,.GIF, .jpg,.JPG, .jpeg,.JPEG, .png,.PNG, .bmp,.BMP, .doc,.DOC, .docx,.DOCX"
            (change)="onFileSelected($event,message.MessageAttachments)" />
          <div class="upload-info">
            <span data-toggle="tooltip"
              title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">
              {{'FRONT_USER.AllowedFileExtentionsTitle' | translate}}
            </span>
            <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
          </div>
        </div>
      </div>
      <div class="chat-footer" data-toggle="collapse" data-target="#chat-pop" aria-expanded="false"
        aria-controls="chat-pop">
        <label> <span class="icon-email"></span>{{messageBoxTitle}}</label>
      </div>
    </div>
  </div>
</div>
